import { humanise } from 'module/ui/components/atoms/humanised-date';
import { Tag } from 'module/ui/components/atoms/tag';
import {
  SignalFrequency,
  SignalOccurrenceGroupedForUser,
} from 'api/account-people/signal-occurrence-types';
import { SignalType } from 'api/signal/types';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';

const signalFrequencyTag = (
  signalFrequency: SignalFrequency,
  firstReportedAt?: string,
) => {
  const firstReportedAtMoment = firstReportedAt ? (
    <>
      {' '}
      (
      <FormattedMessage
        id="account.people.signal_frequency.first_reported_on"
        values={{ date: humanise(moment(firstReportedAt)) }}
      />
      )
    </>
  ) : null;

  switch (signalFrequency) {
    case 'PERSISTENT':
      return (
        <Tag color="red">
          <FormattedMessage id="account.people.signal_frequency.persistent" />
          {firstReportedAtMoment}
        </Tag>
      );
    case 'ONE_OFF':
      return (
        <Tag color="cyan">
          <FormattedMessage id="account.people.signal_frequency.one_time" />
          {firstReportedAtMoment}
        </Tag>
      );
    case 'INTERMITTENT':
      return (
        <Tag color="yellow">
          <FormattedMessage id="account.people.signal_frequency.intermittent" />
          {firstReportedAtMoment}
        </Tag>
      );
    default:
      return null;
  }
};

interface Props {
  signalType: SignalType;
  signalOccurrence: SignalOccurrenceGroupedForUser;
}
export const HeaderTag = ({ signalType, signalOccurrence }: Props) => {
  return signalType === SignalType.Risk ? (
    signalFrequencyTag(
      signalOccurrence.signalFrequency,
      signalOccurrence.firstReportedAt,
    )
  ) : (
    <Tag color="purple">
      {humanise(moment(signalOccurrence.lastReportedAt))}
    </Tag>
  );
};
